import { StepKey } from '../../enums/stepKey';
import { getRoutes } from './getRoutes';

/**
 * @description This function takes the current step key and journey type as arguments and returns the path of the previous step in the journey.
 *
 * It first retrieves the routes for the given journey type, filters out any routes that do not have a stepKey,
 * and then finds the index of the current step key in the filtered routes.
 * If the current step key is not found or is the first step in the routes, it returns null. Otherwise, it returns the path of the previous step.
 *
 * This is the core place of the logic for determining navigation between steps in the application,
 * and it relies on the structure of the routes defined for each journey type.
 */
export const getPreviousStepPath = (stepKey: StepKey, journeyType: 'control' | 'test') => {
  const { formStepRoutes } = getRoutes(journeyType);
  const currentRouteIndex = formStepRoutes.findIndex((route) => route.stepKey === stepKey);
  if (currentRouteIndex <= 0) {
    return null;
  }
  return formStepRoutes[currentRouteIndex - 1].path;
};
